export const PURCHASE_ORDER_REGISTER_REPORT_REQUEST = 'PURCHASE_ORDER_REGISTER_REPORT_REQUEST';
export const PURCHASE_ORDER_REGISTER_REPORT_SUCCESS = 'PURCHASE_ORDER_REGISTER_REPORT_SUCCESS';
export const PURCHASE_ORDER_REGISTER_REPORT_FAILURE = 'PURCHASE_ORDER_REGISTER_REPORT_FAILURE';